import { render, staticRenderFns } from "./SeminarApplicationsPanel.vue?vue&type=template&id=4c4aee75&"
import script from "./SeminarApplicationsPanel.vue?vue&type=script&lang=js&"
export * from "./SeminarApplicationsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports